import PedidoController from "@/shared/controllers/pedido/PedidoController";
import PedidoObservacoesViewModel from "@/shared/view-models/PedidoObservacoesViewModel";
import DetalhesDoPedidoFluxoViewModel from "@/shared/view-models/DetalhesDoPedidoFluxoViewModel";
import Tools from "@/shared/services/tools";
import { defineComponent } from "vue";

const name = 'ObservacoesPedidoEmAndamentoPDF'
export default defineComponent({
  name,


  components: {},


  props: {},


  mounted() {
    this.pedidoId = this.$route.params.id
    this.numeroParcela = this.$route.params.numeroParcela
    this.getDetalhesObservacoes()
  },


  updated() { },


  data() {
    return {
      pedidoId: null,
      numeroParcela: null,
      observacoesInfoArray: [],
      CompFaseArray: [],
      observacoesPedidoAndamento: new PedidoObservacoesViewModel(),
      detalhesDoPedidoFluxo : new DetalhesDoPedidoFluxoViewModel(),
    }
  },

  methods: {
  
    voltar() {
      this.$router.back()
    },

    getDetalhesDoPedido() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesDoPedidoFluxo/${this.$route.params.id}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.detalhesDoPedidoFluxo, Tools.captalizeKeys(response.data.data))
          this.executaTermino()
        })
        .catch(() => {
        });
    },


    getDetalhesObservacoes() {
      PedidoController.GetDetalhesObservacoesPedidoAndamento(this.pedidoId, this.numeroParcela).requisicao
        .then((res => {
          Tools.objectCustomAssign(this.observacoesPedidoAndamento, Tools.captalizeKeys(res.data.data))
          this.getObservacoes()
        }))
        .catch(() => {
        })
    },


    getObservacoes() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetObservacoesDoPedido/${this.$route.params.id}/${this.numeroParcela}`,
      })
        .then((response) => {
          this.observacoesInfoArray = response.data.data;
          this.GetComponentesEFases()
        })
        .catch(() => {
        });
    },

    GetComponentesEFases(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetPedidosComponentesParcela/${this.$route.params.id}/${this.numeroParcela}`,
      })
        .then((response) => {
          this.CompFaseArray = response.data.data;
          this.getDetalhesDoPedido();
        })
        .catch(() => {
        });
    },


  },
  executaTermino(){
    this.$emit('termino')
  },  

  computed: {},

});